export const get_tabs = (state) => {
  return state.tabs;
};
